const BASE_API = process.env.REACT_APP_BASE_API || "https://tnwc.co.in";

export { BASE_API };